var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhiteinstaicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:#cc121d;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.265 -0.208)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 25,
    cy: 25,
    r: 25,
    transform: "translate(0.265 0.209)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.401 15.401)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M391.727,676.149a1.147,1.147,0,1,0,1.147,1.147A1.147,1.147,0,0,0,391.727,676.149Zm-5.1,1.471a4.818,4.818,0,1,0,4.818,4.818A4.824,4.824,0,0,0,386.628,677.62Zm0,7.9a3.086,3.086,0,1,1,3.086-3.086A3.09,3.09,0,0,1,386.628,685.524Zm9.722-7.09a5.876,5.876,0,0,0-5.877-5.877h-7.756a5.877,5.877,0,0,0-5.877,5.877v7.757a5.876,5.876,0,0,0,5.877,5.876h7.756a5.876,5.876,0,0,0,5.877-5.876Zm-1.841,7.757a4.036,4.036,0,0,1-4.036,4.036h-7.756a4.036,4.036,0,0,1-4.037-4.036v-7.757a4.037,4.037,0,0,1,4.037-4.036h7.756a4.036,4.036,0,0,1,4.036,4.036Z",
    transform: "translate(-376.84 -672.557)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteinstaicon);
export default __webpack_public_path__ + "static/media/whiteinstaicon.a86d1ff27cf331eeb5525971f3fd5d1a.svg";
export { ForwardRef as ReactComponent };